import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDirectionDropoffBg = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 20,
	viewBox: "0 0 44 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 44,
			height: 20,
			rx: 10,
			fill: "#F3E5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.5 12.375V11.25H38V14.625C38 15.2344 37.4609 15.75 36.875 15.75H27.125C26.5156 15.75 26 15.2344 26 14.625V11.25H30.5V12.375C30.5 12.5859 30.6641 12.75 30.875 12.75H33.125C33.3125 12.75 33.5 12.5859 33.5 12.375ZM36.875 6.75C37.4609 6.75 38 7.28906 38 7.875V10.5H26V7.875C26 7.28906 26.5156 6.75 27.125 6.75H29V5.625C29 5.03906 29.5156 4.5 30.125 4.5H33.875C34.4609 4.5 35 5.03906 35 5.625V6.75H36.875ZM33.875 6.75V5.625H30.125V6.75H33.875Z",
			fill: "#AA00FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.44 9H6L8.46 11.46L13.36 16.36L15.09 14.61L11.94 11.46H20.61V9H8.63H8.44Z",
			fill: "#AA00FF"
		})
	]
});
const ForwardRef = forwardRef(SvgDirectionDropoffBg);
export { ForwardRef as ReactComponent };
